export enum SubscriptionPlanTier {
    Trial = "trial",
    Professional = "professional",
    Premium = "premium",
    Enterprise = "enterprise",
}
